import React from 'react';
import { Box } from '@mui/material';
import { Typography, colors } from '@leapeasy/ui-kit';

export const DetailItem = ({ label, value, isLastItem = false }) => {
  const rows = (label || [])
    .map((item, index) => ({ label: item, value: (value || [])[index] }))
    .filter((item) => item.label);

  return (
    <Box
      flexGrow={1}
      fontWeight={500}
      borderRight={!isLastItem && `1px solid ${colors.purple[200]}`}
    >
      {rows.map((row, index) => (
        <Box
          key={`${row.label}-${index}`}
          width="fit-content"
          marginLeft="20px"
          paddingTop={index === 0 ? '2px' : '15px'}
          whiteSpace="nowrap"
        >
          <Typography variant="body3" style={{ color: colors.black[600], marginBottom: 8 }}>
            {row.label}
          </Typography>
          <Typography variant="body3" style={{ color: colors.purple[900] }}>
            {row.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
